import PropTypes from 'prop-types'
import { Tooltip as ReactTooltip } from 'react-tooltip'

import styled from 'styled-components'

import colors from 'components/utils/colors'

const bgColor = colors.secondary20
const Z_INDEX_TOOLTIP = 1500

// transition should not be set to 'none' as it remain Tooltip in DOM
// with possible invisible but clickable objects
// see https://react-tooltip.com/docs/examples/styling
const StyledReactTooltip = styled(ReactTooltip)`
  && {
    background-color: ${bgColor};
    color: #FFFFFF;
    font-size: 12px;
    font-weight: 600;
    line-height: 14px;
    padding: 11px;
    max-width: ${props => props.$maxWidth || 'initial'};
    word-break: break-word;
    z-index: ${Z_INDEX_TOOLTIP};
    transition: 0.001s;

    /* v6 wraps content in an inner element which brings its own padding */
    > .react-tooltip-content-wrapper {
      padding: 0;
      /* v6 dropped HTML string content, so newline characters are used for line breaks */
      white-space: pre-line;
    }

    &.react-tooltip__place-top > .react-tooltip-arrow {
      transform: scaleX(1.4) rotate(45deg);
    }
    &.react-tooltip__place-right > .react-tooltip-arrow {
      transform: scaleY(0.9) rotate(135deg);
    }
    &.react-tooltip__place-bottom > .react-tooltip-arrow {
      transform: scaleX(1.4) rotate(225deg);
    }
    &.react-tooltip__place-left > .react-tooltip-arrow {
      transform: scaleY(0.9) rotate(315deg);
    }
  }
`

const Tooltip = ({
  children, id, place = 'top', maxWidth, clickable, delayHide, hidden,
  openEvents, closeEvents,
}) => {
  return (
    <StyledReactTooltip
      id={id}
      place={place}
      $maxWidth={maxWidth}
      clickable={clickable}
      delayHide={delayHide}
      hidden={hidden}
      openEvents={openEvents}
      closeEvents={closeEvents}
      opacity={1}
      offset={12}
      positionStrategy='fixed'
    >
      {children}
    </StyledReactTooltip>
  )
}

Tooltip.propTypes = {
  children: PropTypes.node,
  id: PropTypes.string,
  place: PropTypes.string,
  maxWidth: PropTypes.string,
  clickable: PropTypes.bool,
  delayHide: PropTypes.number,
  hidden: PropTypes.bool,
  openEvents: PropTypes.objectOf(PropTypes.bool),
  closeEvents: PropTypes.objectOf(PropTypes.bool),
}

export default Tooltip
